import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import "../styles/Navbar.css";

const Navbar = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const refreshHome = () => {
    navigate("/");
    window.location.reload(); // Forces a full refresh
    setMenuOpen(false); // Close mobile menu
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleNavClick = (href) => {
    setMenuOpen(false); // Close mobile menu when clicking nav items
    
    if (href.startsWith('#')) {
      // Smooth scroll to section
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuOpen && !event.target.closest('.navbar')) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [menuOpen]);

  return (
    <>
      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <h1
          className="navbar-title"
          onClick={refreshHome}
          style={{ cursor: "pointer" }}
        >
          Trans<span className="highlight">cripto</span>
        </h1>

        <div className={`navbar-links ${menuOpen ? "active" : ""}`}>
          <a 
            href="#about" 
            className="nav-link"
            onClick={() => handleNavClick('#about')}
          >
            About
          </a>
          <a 
            href="#faq" 
            className="nav-link"
            onClick={() => handleNavClick('#faq')}
          >
            FAQ
          </a>
          <a 
            href="#" 
            className="nav-link"
            onClick={refreshHome}
          >
            Donate
          </a>
          <button className="new-button" onClick={refreshHome}>
            New +
          </button>
        </div>

        <div className={`hamburger ${menuOpen ? 'active' : ''}`} onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <div className={`mobile-menu ${menuOpen ? 'active' : ''}`}>
        <a 
          href="#about" 
          className="nav-link"
          onClick={() => handleNavClick('#about')}
        >
          About
        </a>
        <a 
          href="#faq" 
          className="nav-link"
          onClick={() => handleNavClick('#faq')}
        >
          FAQ
        </a>
        <a 
          href="#" 
          className="nav-link"
          onClick={() => handleNavClick('#')}
        >
          Donate
        </a>
        <button className="new-button" onClick={refreshHome}>
          New +
        </button>
      </div>
    </>
  );
};

export { Navbar };